import LogoLabel from './LogoLabel';
import type { LogoLabelProps } from './types';

export default LogoLabel;
export type { LogoLabelProps };
